import { Spinner } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function LoadingPage() {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen items-center justify-center bg-backgrounds-secondary">
      <Spinner size="lg">{t('actions.loading')}</Spinner>
    </div>
  );
}
